/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';

export default class AcceptInvitationMutation extends Relay.Mutation {
    static fragments = {
        invitation: () => Relay.QL`
              fragment on Invitation {
                    organisation_id,
                    id,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {acceptInvitation}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on AcceptInvitationPayload {
                success,
                error,
                organisation {
                    id,
                    realId,
                    name
                },
                user {
                    organisations2user(first: 10000) {
                        edges {
                            node {
                                id,
                                organisation_id,
                                role,
                                permissions,
                            }
                        }
                    },
                    organisations (first: 10000) {
                        edges {
                            node {
                                id
                            }
                        }
                    }
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'FIELDS_CHANGE',
            fieldIDs: {
                user: 1,
            },
        }];
    }

    getVariables() {
        return {
            invitation_id: this.props.invitation.id,
            secret: this.props.secret,
        };
    }
}
